import { getData, postData, putData, deleteData } from '../utils/fetch-api';

const baseSlsUrl = `${process.env.REACT_APP_BASE_API_URL}`;

class BrazeService {
  listCampaigns() {
    return getData(`${baseSlsUrl}braze/campaigns/list`);
  }

  triggerCampaign(payload) {
    return postData(`${baseSlsUrl}braze/campaigns/trigger/send`, payload);
  }

  // WWW-15543 — send an ad-hoc test push to explicit recipients via Braze
  // /messages/send. Unlike triggerCampaign this is NOT gated by a campaign's
  // target segment, so a tester receives the push regardless of segment
  // membership. Payload: { title?, body, deep_link?, image_url?, arc_id?,
  // article_link?, is_direct_url?, recipients: [{ email } | { external_user_id }] }.
  sendTestMessage(payload) {
    return postData(`${baseSlsUrl}braze/campaigns/test-send`, payload);
  }

  // WWW-15236 — all scheduling actions share the one `/campaigns/schedule`
  // endpoint, distinguished by HTTP method. POST (create) mirrors triggerCampaign
  // plus `schedule_time` (ISO-8601) and returns { schedule_id }; PUT reschedules;
  // DELETE cancels.
  scheduleCampaign(payload) {
    return postData(`${baseSlsUrl}braze/campaigns/schedule`, payload);
  }

  // Reschedule an existing send: { campaign_id, schedule_id, schedule_time }.
  updateScheduledCampaign(payload) {
    return putData(`${baseSlsUrl}braze/campaigns/schedule`, payload);
  }

  // Cancel a scheduled send: { campaign_id, schedule_id }.
  deleteScheduledCampaign(payload) {
    return deleteData(`${baseSlsUrl}braze/campaigns/schedule`, payload);
  }

  getAudienceEstimate(campaignIds) {
    const ids = encodeURIComponent((campaignIds || []).join(','));

    return getData(`${baseSlsUrl}braze/campaigns/audience-estimate?campaign_ids=${ids}`);
  }
}

export { BrazeService };
export default new BrazeService();
